import { Button, ButtonGroup } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import {
  usePostAlerts,
  usePostReadAll,
} from '~/react-query-hooks/events/use-event-alerts/useEventAlerts';
import { appPaths } from '~/routes/app-paths';

import styles from './Header.module.scss';
import { TooltipContainer } from '~/components/tooltip-container/TooltipContainer';

export interface HeaderProps {
  activeButtonIndex: number;
  onButtonClick: (index: number) => void;
  onClose: () => void;
}

export const Header = ({
  activeButtonIndex,
  onButtonClick,
  onClose,
}: HeaderProps) => {
  const { t } = useTranslation('alerts');
  const navigate = useNavigate();
  const { mutate: readAllAlerts } = usePostReadAll();
  const { data } = usePostAlerts({ count_only: true });
  const unreadCount = data?.pages[0]?.unread_count ?? 0;

  const handleNavigateToAlerts = () => {
    onClose();
    navigate(appPaths.alerts);
  };

  const buttonLabels = [
    t('alerts:all'),
    t('alerts:unread', { count: unreadCount }),
  ];

  return (
    <div className={styles.headerWrapper}>
      <div className={styles.titleAndButtonRow}>
        <div className={styles.title}>{t('dropdown.title')}</div>
        <div className={styles.buttonContainer}>
          <TooltipContainer
            label={
              <div className={styles.tooltipLabel}>
                {t('alerts:dropdown.markAllAsRead')}
              </div>
            }
          >
            <Button
              variant="empty"
              size="xsmall"
              iconName="CheckDouble"
              onClick={() => readAllAlerts()}
            />
          </TooltipContainer>
          <TooltipContainer
            label={
              <div className={styles.tooltipLabel}>
                {t('alerts:dropdown.viewAllAlerts')}
              </div>
            }
          >
            <Button
              variant="empty"
              size="xsmall"
              iconName="Expand"
              onClick={handleNavigateToAlerts}
            />
          </TooltipContainer>
        </div>
      </div>
      <ButtonGroup
        className={styles.styledButtonGroup}
        labels={buttonLabels}
        activeIndex={activeButtonIndex}
        onClick={onButtonClick}
      />
    </div>
  );
};
